export default function getGlobal()
{

    //return "https://digital.currenmexico.com/cotizador/"  // Este es el acceso global

    return  "http://localhost:3005/legaltek/"


}